// noinspection JSUnresolvedVariable

import { Button, ButtonGroup, Col, Dropdown, Nav, Row } from 'react-bootstrap'
import { cloneElement, useEffect, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Api } from '../../../api/api.js'
import { Flip, toast } from 'react-toastify'
import { useWizardMapping } from '../../../api/app/queries/useWizardMapping.jsx'
import { useWizardData } from '../../../api/app/queries/useWizardData.jsx'
import { clearData, setData } from '../../../redux/wizard.js'
import { useDispatch } from 'react-redux'

const Wizard = (props) => {
    const dispatch = useDispatch()
    const categoryField = props.categoryField || 'kategoria'

    // const cleanForm = () => dispatch(wizClean(props.name))
    const cleanForm = () => null
    // const storeForm = (data) => dispatch(wizSetData(props.name, data))

    const storedForm = useSelector(
        (state) => state.wizard?.[props.name]?.data || {}
    )
    // const storeMeta = (key, value) =>
    //     dispatch(wizSetMeta(props.name, key, value))
    const storeMeta = () => null
    const storedMeta = useSelector(
        (state) => state.wizard?.[props.name]?.meta || {}
    )

    const [busy, setBusy] = useState(false)
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(0)
    const initUrl = props.stateForPage
        ? props.dataUrl + '/' + props.pages[page].name
        : props.dataUrl
    const [dataUrl, setDataUrl] = useState(initUrl)

    const [pageKey, setPageKey] = useState(props.pages[0].page)
    const [form, setForm] = useState(storedForm)
    const [meta, setMeta] = useState(storedMeta)
    const [toElement, setToElement] = useState()
    const [summary, setSummary] = useState([])

    const mapping = useWizardMapping(props.mappingUrl, props.name)
    const storeForm = (data) => dispatch(setData(data))
    const itemData = useWizardData(dataUrl, props.name)

    const filterByCategory = props.filterByCategory === true

    const getField = (field, _page) => {
        const path = field.split('.').filter((n) => !/^\d+$/.test(n))
        const obj = _page
            ? mapping?.data?.find((p) => p.name === _page) || {}
            : mapping?.data?.[page] || {}

        const filteredPath =
            obj.name && path[0] === obj.name ? path.slice(1) : path

        return filteredPath.reduce((o, key) => {
            if (!o?.fields) return {}
            const found = o.fields.find((f) => f.name === key)
            return found || {}
        }, obj)
    }

    const getLp = (field, _page) => {
        return getField(field, _page)?.lp || `brak mapowania (${field})`
    }
    const getLabel = (field, _page) => {
        return getField(field, _page)?.label || `brak mapowania (${field})`
    }
    const getToolTip = (field, _page) => {
        return getField(field, _page)?.tooltip || undefined
    }
    const getDisplay = (field, _page) => {
        return getField(field, _page)?.display || true
    }
    const getType = (field, _page) => {
        return getField(field, _page)?.type || 'input'
    }
    const getMax = (field, _page) => {
        return getField(field, _page)?.max || undefined
    }
    const getDecimal = (field, _page) => {
        return getField(field, _page)?.decimal ?? 2
    }

    useEffect(() => {
        if (props.dataUrl) {
            const extra = props.pages[page]?.extra
                ? '?extra=' + props.pages[page].extra.join(',')
                : ''
            if (!props.stateForPage) {
                setDataUrl(props.dataUrl)
            } else {
                setDataUrl(props.dataUrl + '/' + props.pages[page].name + extra)
            }
        }

        // eslint-disable-next-line
    }, [props.pages[page].name, props.dataUrl])

    useEffect(
        () => {
            setMeta({})
            cleanForm()
            dispatch(clearData())
        },
        // eslint-disable-next-line
        []
    )

    useEffect(() => {
        setBusy(true)

        if (itemData?.data) {
            setForm(itemData?.data)
            storeForm(itemData?.data)
            setBusy(false)

            // if (response.status === 422) {
            //     setSummary(data)
            // }
        }
        // eslint-disable-next-line
    }, [itemData?.isSettled, itemData?.data])

    useEffect(() => {
        if (toElement) {
            document.getElementById(toElement)?.scrollIntoView()
            setToElement(null)
        }

        if (
            props.pages[page]?.summary &&
            !props.stateForPage //@ zapobiega podwójnemu wywołaniu walidacji w WOD
        ) {
            setBusy(true)
            Api(props.validationUrl)
                .then((res) => {

                    if (res.status === 422) {
                        setSummary(res.data)
                    }
                })
                .catch((error) => {
                    console.error('Validation API call failed:', error)
                    // Reset summary on error to prevent stale data
                    setSummary([])
                })
                .finally(() => {
                    setBusy(false)
                })
        }
        return () => {
            setSummary([])
            setBusy(false)
        }
        // eslint-disable-next-line
    }, [page])

    useEffect(() => {
        if (!allowedIndexes || allowedIndexes.length === 0) return

        if (!isAllowedIndex(page)) {
            const first = allowedIndexes[0]
            setPage(first)
            setPageKey(
                props.pages[first]?.page ??
                    props.pages[first]?.name ??
                    props.pages[first]
            )
        }
    }, [mapping?.data, itemData?.data])

    const setValue = (key, value) => {
        let f = { ...form }
        if (props.stateForPage) {
            if (f[pageKey]) {
                f[pageKey][key] = value
            } else {
                f[pageKey] = { [key]: value }
            }
            if (props.pages[page]?.calc) {
                f[pageKey] = props.pages[page].calc(f[pageKey])
            }
        } else {
            if (props.pages[page]?.calc) {
                f = props.pages[page].calc({ ...f, [key]: value }) || {}
            } else {
                f[key] = value
            }
        }
        setForm(f)
        storeForm(f)
        return f
    }

    const setWizForm = (form) => {
        let f = { ...form }
        if (props.pages[page]?.calc) {
            f = props.pages[page].calc(f) || {}
        }
        setForm(f)
        storeForm(f)
        return f
    }

    const appendData = (page, data) => {
        const f = { ...form }
        f[page] = data
        setForm(f)
        storeForm(f)
    }

    const setValidation = (validation) => {
        setMeta((meta) => ({ ...meta, validation }))
        storeMeta('validation', validation)
    }

    // Nowa logika obliczeń na podstawie mapowania (kategoria)
    const allowedIndexes = useMemo(() => {
        const mappedPages = mapping?.data || []
        if (!filterByCategory) {
            return props.pages.map((p, i) => i)
        }

        const projectCategory = itemData?.data?.[categoryField] || null
        let pagesToRender

        if (!projectCategory) {
            pagesToRender = mappedPages
        } else {
            pagesToRender = mappedPages.filter((m) =>
                Array.isArray(m.categories)
                    ? m.categories.includes(projectCategory)
                    : true
            )
        }

        const indexes = pagesToRender
            .map((currentPage) => {
                return props.pages.findIndex((p) => p.name === currentPage.name)
            })
            .filter((idx) => idx !== -1)

        return Array.from(new Set(indexes)).sort((a, b) => a - b)
    }, [
        mapping?.data,
        itemData?.data,
        filterByCategory,
        categoryField,
        props.pages,
    ])

    const isAllowedIndex = (idx) => allowedIndexes.includes(idx)

    const nextVisibleIndex = (currentIdx) => {
        const pos = allowedIndexes.indexOf(currentIdx)
        if (pos === -1) {
            const bigger = allowedIndexes.find((i) => i > currentIdx)
            return typeof bigger !== 'undefined'
                ? bigger
                : allowedIndexes.length
                ? allowedIndexes[0]
                : currentIdx
        }
        return pos < allowedIndexes.length - 1
            ? allowedIndexes[pos + 1]
            : currentIdx
    }

    const prevVisibleIndex = (currentIdx) => {
        const pos = allowedIndexes.indexOf(currentIdx)
        if (pos === -1) {
            const smaller = [...allowedIndexes]
                .reverse()
                .find((i) => i < currentIdx)
            return typeof smaller !== 'undefined'
                ? smaller
                : allowedIndexes.length
                ? allowedIndexes[allowedIndexes.length - 1]
                : currentIdx
        }
        return pos > 0 ? allowedIndexes[pos - 1] : currentIdx
    }

    const safeSetPage = (toIdx, toElementParam) => {
        const targetIdx = isAllowedIndex(toIdx)
            ? toIdx
            : allowedIndexes.length
            ? allowedIndexes.find((i) => i >= toIdx) ?? allowedIndexes[0] // Znajdź najbliższy następny lub pierwszy
            : 0

        setPage(targetIdx)
        if (props.stateForPage) itemData?.refetch()
        if (!props.pages[targetIdx].disabled)
            setPageKey(props.pages[targetIdx].name)
        setToElement(toElementParam)
        setBusy(false)
    }

    // const setPageByName = (pageName, toElement) => {
    //     const index = mapping?.data.findIndex((m) => m.name === pageName)
    //     pageName && setPageKey(pageName)
    //     setPage(index)
    //     setToElement(toElement)
    // }
    const setPageByName = (pageName, toElement) => {
        const mappedName = mapping?.data.find((m) => m.name === pageName)?.name
        const originalIndex = props.pages.findIndex(
            (p) => p.name === mappedName
        )
        if (originalIndex === -1) return
        setPageKey(pageName)
        safeSetPage(originalIndex, toElement)
    }

    const save = async () => {
        const dataForm = props.addData ? { ...form, ...props.addData } : form
        !props.pages[page].noPayload &&
            (await Api.put(
                props.saveUrl + (props.stateForPage ? `/${pageKey}` : ''),
                dataForm
            ).then((res) => {
                if (res?.data?.status === 'success') {
                    toast.success('Zapisano dane', {
                        autoClose: 1500,
                        hideProgressBar: true,
                        pauseOnHover: false,
                        transition: Flip,
                        closeOnClick: true,
                    })
                }
            }))
    }

    const saveAndQuit = () => {
        save().then(() => {
            props.saveAndQuitCallback()
        })
    }

    // const completeNav = (toPage) => {
    //     setPage(toPage)
    //     if (props.stateForPage) {
    //         itemData?.refetch()
    //     }
    //
    //     if (!props.pages[toPage].disabled) setPageKey(props.pages[toPage].name)
    //     setBusy(false)
    // }

    const completeNav = (toPage) => {
        safeSetPage(toPage)
    }

    // const nav = (toPage) => {
    //     // if (!props.pages[toPage].disabled) { //@ deprecated
    //     setBusy(true)
    //     if (
    //         props.saveOnPageChange &&
    //         props.mode === 'edycja' &&
    //         !props.pages[page].summary
    //     ) {
    //         save().then(() => {
    //             completeNav(toPage)
    //         })
    //     } else {
    //         completeNav(toPage)
    //     }
    //     // }
    // }

    const nav = (toPage) => {
        setBusy(true)

        let target = toPage

        if (toPage === 'next') {
            target = nextVisibleIndex(page)
        } else if (toPage === 'prev') {
            target = prevVisibleIndex(page)
        }

        if (
            props.saveOnPageChange &&
            props.mode === 'edycja' &&
            !props.pages[page].summary
        ) {
            save()
                .then(() => {
                    if (props.pages[target]?.summary) {
                        itemData?.refetch()
                    }
                    completeNav(target)
                })
                .catch(() => {
                    setBusy(false)
                })
        } else {
            completeNav(target)
        }
    }

    const clearFields = (fields, object = undefined, index = undefined) => {
        const f = { ...form }
        if (object && index !== undefined) {
            fields.forEach((field) => {
                delete f[object][index][field]
            })
        } else {
            fields.forEach((field) => {
                delete f[field]
            })
        }
        setForm(f)
        storeForm(f)
    }

    const renderForm = (page) => {
        return (
            <div className={'w-100'}>
                {cloneElement(props.pages[page].form, {
                    wiz: {
                        form,
                        setValue,
                        setForm,
                        setWizForm,
                        page,
                        pageKey,
                        setPage,
                        setPageByName,
                        validationUrl: props.validationUrl,
                        validation: meta.validation,
                        setValidation,
                        mapping: mapping?.data,
                        getLp,
                        getLabel,
                        getToolTip,
                        getDisplay,
                        appendData,
                        getType,
                        getMax,
                        getDecimal,
                        stateForPage: props.stateForPage,
                        loading,
                        setLoading,
                        summary,
                        refetch: itemData.refetch,
                        clearFields,
                    },
                })}
            </div>
        )
    }

    const renderNav = () => {
        const isFirstAllowedPage = allowedIndexes[0] === page
        const isLastAllowedPage =
            allowedIndexes[allowedIndexes.length - 1] === page

        return (
            <ButtonGroup className={'border-1 bg-white p-2'} size='sm'>
                {!isFirstAllowedPage && (
                    <Button variant={'secondary'} onClick={() => nav('prev')}>
                        Wstecz
                    </Button>
                )}

                {props.mode === 'edycja' && !loading ? (
                    <>
                        <Button
                            variant={'secondary'}
                            onClick={props.cancelCallback}
                            className={'mx-1'}
                        >
                            Anuluj i wyjdź
                        </Button>

                        {!isLastAllowedPage && (
                            <Dropdown>
                                <div>
                                    <Button
                                        onClick={save}
                                        className='split'
                                        variant='primary'
                                    >
                                        Zapisz
                                    </Button>
                                    <Dropdown.Toggle
                                        split
                                        aria-label={'dropdown'}
                                        variant='primary'
                                        id='dropdown-split-basic'
                                    />
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            variant='primary'
                                            href='#/action-1'
                                        >
                                            <Button
                                                onClick={saveAndQuit}
                                                className='split'
                                                variant='primary'
                                            >
                                                Zapisz i wyjdź
                                            </Button>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </div>
                            </Dropdown>
                        )}

                        {page === props.pages.length - 1 &&
                            !meta?.validation?.find(
                                (e) => e.type === 'error'
                            ) &&
                            !summary.error &&
                            (!busy || !loading) &&
                            props?.acceptButtons(summary)}
                        {(page === props.pages.length - 1 &&
                            !!props?.customButtons &&
                            props?.customButtons()) ||
                            ''}
                    </>
                ) : (
                    <>
                        <Button
                            disabled={true}
                            className={'btn btn-outline-dark ms-1'}
                            variant={'warning'}
                        >
                            Tryb tylko do odczytu
                        </Button>
                    </>
                )}

                {!isLastAllowedPage && (
                    <Button
                        variant={'success'}
                        onClick={() => nav('next')}
                        className={'ms-1'}
                    >
                        Dalej
                    </Button>
                )}
            </ButtonGroup>
        )
    }

    const renderSideNav = () => {
        const mappedPages = mapping?.data
        const projectCategory = filterByCategory
            ? itemData?.data?.[categoryField]
            : null

        if (!mappedPages) {
            return (
                <Nav
                    className={'flex-column text-nowrap text-start'}
                    variant='pills'
                >
                    <Nav.Item>Ładowanie...</Nav.Item>
                </Nav>
            )
        }

        // Jeżeli nie filtrujemy po kategorii — domyślne zachowanie: renderujemy wszystkie props.pages
        if (!filterByCategory) {
            return (
                <Nav
                    className={'flex-column text-nowrap text-start'}
                    variant='pills'
                    defaultActiveKey='/home'
                >
                    {props.pages.map((p, i) => (
                        <Nav.Item key={i}>
                            <div>
                                <Nav.Link
                                    disabled={p?.disabled || loading || busy}
                                    onClick={() => nav(i)}
                                    active={page === i}
                                >
                                    {mappedPages.find((m) => m.name === p.name)
                                        ?.label || `brak mapowania (${p.name})`}
                                </Nav.Link>
                            </div>
                        </Nav.Item>
                    ))}
                </Nav>
            )
        }

        // tutaj filterByCategory === true => filtrujemy mapping po kategorii projektu
        const pc = projectCategory
        // fallback: jeśli nie ma projectCategory, nie filtrujemy (pokazujemy wszystkie mapping.pages)
        let pagesToRender
        if (!pc) {
            pagesToRender = mappedPages
        } else {
            pagesToRender = mappedPages.filter((m) =>
                Array.isArray(m.categories) ? m.categories.includes(pc) : true
            )
        }

        return (
            <Nav
                className={'flex-column text-nowrap text-start'}
                variant='pills'
                defaultActiveKey='/home'
            >
                {pagesToRender.map((currentPage, i) => {
                    const originalIndex = props.pages.findIndex(
                        (p) => p.name === currentPage.name
                    )
                    if (originalIndex === -1) return null
                    return (
                        <Nav.Item key={i}>
                            <div>
                                <Nav.Link
                                    disabled={
                                        currentPage?.disabled || loading || busy
                                    }
                                    onClick={() => nav(originalIndex)}
                                    active={page === originalIndex}
                                >
                                    {mappedPages.find(
                                        (m) => m.name === currentPage.name
                                    )?.label ||
                                        `brak mapowania (${currentPage.name})`}
                                </Nav.Link>
                            </div>
                        </Nav.Item>
                    )
                })}
            </Nav>
        )
    }

    return (
        <>
            <Row>
                <Col lg={2} className={'nav-width'}>
                    {renderSideNav()}
                </Col>
                {/* dla drugiej kolumny brak lg={10} <=> kolumna płynnie wykorzystuje dostępną szerokość*/}
                <Col>
                    <div className={'d-flex'}>{renderNav()}</div>
                    {renderForm(page)}
                    <div className={'d-flex sticky-bottom my-3'}>
                        {renderNav()}
                    </div>
                </Col>
            </Row>
        </>
    )
}

Wizard.propTypes = {
    name: PropTypes.string.isRequired, //unikalna nazwa wizarda
    mode: PropTypes.string.isRequired, //view, edit
    pages: PropTypes.array.isRequired, //lista komponentow, zakladek
    dataUrl: PropTypes.string.isRequired, //url do pobierania danych
    saveUrl: PropTypes.string, //url do zapisu wszystkich danych
    mappingUrl: PropTypes.string.isRequired, //mapowanie stron i pol
    validationUrl: PropTypes.string, //url do walidacji na podsumowaniu
    stateForPage: PropTypes.bool,
    saveOnPageChange: PropTypes.bool.isRequired,
    saveAndQuitCallback: PropTypes.func, //callback do wykonania po zapisie
    cancelCallback: PropTypes.func, //callback do wukonania przy anulowaniu
    customButtons: PropTypes.func,
    debug: PropTypes.bool, //card ze stanem wizarda
    addData: PropTypes.any, // dodatkowe dane doąłczane obok formularza  w request,
    noPayload: PropTypes.bool,
    acceptButtons: PropTypes.func,
    filterByCategory: PropTypes.bool,
    categoryField: PropTypes.string,
}

export default Wizard
